var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWireframes2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Wireframes",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.975,
    height: 20,
    viewBox: "0 0 39.975 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Specialist---View-directory-profile---TC-LHIN-new-user-v3",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "office-referral",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tm-service"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video-conference"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    d: "M41.071,29.632a.449.449,0,0,1-.4.458H38.022a.45.45,0,0,1-.4-.458V22.37a.452.452,0,0,1,.4-.461h2.645a.451.451,0,0,1,.4.461ZM16.043,28.455A2.458,2.458,0,1,1,18.631,26,2.526,2.526,0,0,1,16.043,28.455ZM41.7,21.26a1.567,1.567,0,0,0-1.008-.364H38.474a1.6,1.6,0,0,0-.389.047V19.616c0-1.052-1.775-2.616-2.976-2.616H12.974C11.775,17,10,18.564,10,19.616V32.382C10,33.436,11.775,35,12.974,35H35.109c1.2,0,2.976-1.564,2.976-2.618V31.055a1.619,1.619,0,0,0,.389.047h2.215a1.565,1.565,0,0,0,.836-.241l6.451,1.573v-12.7Z",
    transform: "translate(-10 -17)",
    fill: "none",
    stroke: "#118847",
    strokeWidth: 2,
    fillRule: "evenodd"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWireframes2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Wireframes-2.2b339e775771f9b4c0c0cb9f2509ab31.svg";